import React from 'react';
import classNames from 'classnames';

interface CircleStepperProps {
  stepsCount: number;
  current: number;
  onClick?: (index: number) => void;
}

const CircleStepper: React.FC<CircleStepperProps> = ({ stepsCount, current, onClick }) => {
  return (
    <div className="flex gap-2">
      {Array.from({ length: stepsCount }, (_, index) => (
        <button
          key={index}
          className={classNames(
            'flex size-[40px] items-center justify-center rounded-full border border-[#4DCCBF]',
            index === current ? 'bg-white' : 'opacity-50',
          )}
          onClick={() => onClick?.(index)}
          style={{ cursor: onClick ? 'pointer' : 'default' }}>
          <span className="text-sh-xxxs font-bold">{index + 1}</span>
        </button>
      ))}
    </div>
  );
};

export default CircleStepper;
